import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="bottom-bar">
                Web development and design by Carleton Barrett Foster III
            </div>
        </footer>
    );
};

export default Footer;